import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Empty, Button, Form, Icon, Tooltip, InputNumber, Input, Popconfirm } from 'antd'
import { infoRequired, validatePassword } from '../../../utils/validators'
import { gerarResgate, gerarResgateTotal } from '../../../redux-flow/actions/contratos'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

// const NoContracts = () => (
//     <Empty description="Nenhum contrato encontrado">
//     </Empty>
// )

const LoadingComponent = () => (
    <div style={{ textAlign: 'center' }}>
        <Icon type="loading" />
    </div>
)

class FormResgateTotal extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            file: null,
            valorInput: 0,
            isSuccess: false
        }
    }

    changeInput = e => {
        this.setState({
            valorInput: e
        })
    }

    refreshPage() {
        setTimeout(function () {
            window.location.reload()
        }, 5000)
    }
    

    // isSuccess = () => {
    //     this.setState({
    //         isSuccess: true
    //     })
    // }

    render() {
        const { form, handleSubmit, tipo, isLoading, contrato, message } = this.props
        let success = this.props.success
        const dateValue = contrato.dataInicio

        return (
            /*Object.keys(contratos).length > 0 ? (*/
                success ? (
                    <div className="finishedSignup">
                        <div>
                            <Row>
                                <Col md={7} style={{ margin: 'auto' }}>
                                    <div>
                                        <h4 className="tx-pink" style={{ textAlign: 'center' }}><b>Pedido de Resgate Total de Saldo Enviado!</b></h4><br />
                                        <p style={{ textAlign: 'center', fontSize: '12px' }}>
                                            Fique de olho em seu e-mail. Em breve, você receberá atualizações sobre seu resgate. <br />
                                        </p><br />
                                        <Button className="btnGrafico"  onClick={() => { this.props.closeModal() }} style={{ width: '30%', height: '36px', display: 'flex', margin: 'auto', alignItems: 'center', justifyContent: 'center' }}>Fechar</Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                ) : (
                    <Form className="formContrato" layout="vertical" onSubmit={handleSubmit(form, contrato.idCliente, contrato.id, contrato.tipoContrato)}>
                        {
                            !success && message != '' ? (
                                <div class="alert alert-danger fade show notificacao-status">
                                    <p className="mb-0">{message}</p>
                                </div> ) : ''
                        }
                        <h4 className="renovacaoTitle">Você optou pelo resgate total de saldo</h4><br />
                        <p>Confirme seus dados bancários para seu pedido de Resgate Total de Saldo</p>
                        <Row>
                        <Col md={4}>
                                <div>
                                    <p className="tx-pink">Produto de Investimento</p>
                                    <p>{tipo === 6 ? ('Flow Digital Assets Spirit') : ('Flow Digital Assets ASA FI')}</p>
                                    <p style={{ visibility: tipo === 6 ? 'hidden' : '' }}>
                                        {tipo === 6 ? '' : contrato.duracao} meses
                                    </p>
                                </div>
                            </Col>
                            <Col md={4}>
                                <p className="tx-pink">Valor do Resgate</p>
                                <p>R$ {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(contrato.ValorContratos[0].valorDia).replace('R$', '')}</p>
                            </Col>
                            <Col md={4}>
                                <p className="tx-pink">Data final do contrato</p>
                                <p>{moment(String(dateValue)).format('DD/MM/YYYY')}</p>
                            </Col>
                            <hr style={{ width: '90%' }} />
                            <Col md={12}>
                                <p className="tx-pink"><b>Dados Bancários</b><Tooltip className="ml-2" title="Caso os dados bancários não estejam corretos ou você não tenha acesso a esta conta, entre em contato com nossa equipe."><FontAwesomeIcon icon={faInfoCircle} /></Tooltip></p>
                            </Col>
                            <Col md={4}>
                                <div>
                                    <p className="tx-pink">Nome do Banco</p>
                                    <p>{contrato.codigoBanco} - {contrato.nomeBanco}</p>
                                </div>
                            </Col >
                            <Col md={4}>
                                <div>
                                    <p className="tx-pink">Agência</p>
                                    <p>{contrato.numeroAgencia}</p>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div>
                                    <p className="tx-pink">Conta</p>
                                    <p>{contrato.numeroConta}</p>
                                </div>
                            </Col>
                            <br />
                        </Row>
                        <div>
                        </div>
                        <Form.Item>
                            {isLoading ? <LoadingComponent /> :
                                <div>
                                    <Button
                                        disabled={isLoading}
                                        className="btnGrafico"
                                        htmlType="submit"
                                        style={{
                                            width: '20%',
                                            float: 'right',
                                            position: 'relative',
                                            marginLeft: '20px'
                                        }}
                                        onClick={this.isSuccess}
                                    >
                                        Confirmar
                                    </Button>
                                </div>}
                        </Form.Item>
                    </Form>
                )
            /*) : <NoContracts />*/
        )
    }
}

const mapStateToProps = state => ({
    logMessage: state.contratos.message,
    isLoading: state.contratos.isLoading,
    success: state.contratos.success,
    userid: state.login.userid,
    contratos: state.contratos.contratos,
    values: state.contratos.values,
    message: state.contratos.message,
})

const mapDispatchToProps = dispatch => ({
    handleSubmit: (form, idCliente, idContrato) => e => {
        e.preventDefault()
        dispatch(gerarResgateTotal(form, idCliente, idContrato))
    }
})

export default Form.create({ name: 'create-resgate' })(
    connect(mapStateToProps, mapDispatchToProps)(FormResgateTotal)
)